import { FunctionComponent } from "react";
import MarqueeBanner from "@views/core/extranet/home/marquee/MarqueeBanner";

interface MarqueeProps {
  errorMessage?: string;
  errorLink?: string;
  labelLink?: string;
  messageType?: string;
}

const Marquee: FunctionComponent<MarqueeProps> = ({
  errorMessage,
  errorLink,
  labelLink,
  messageType,
}) => {
  if (labelLink && labelLink.length > 0 && errorLink && errorLink.length > 0) {
    return (
      <MarqueeBanner
        messageType={messageType}
        errorMessage={errorMessage}
        errorLink={errorLink}
        displayedLink={labelLink}
      />
    );
  } else if (errorLink && errorLink.length > 0) {
    return (
      <MarqueeBanner
        messageType={messageType}
        errorMessage={errorMessage}
        errorLink={errorLink}
        displayedLink={errorLink}
      />
    );
  } else if (errorMessage && errorMessage.length > 0) {
    return (
      <div id="marquee">
        <div className={`marquee-bg bg-${messageType}`}>
          <div className="marquee-elem">
            <h3 className="mb-0">{errorMessage}&nbsp;</h3>
            <h3 className="mb-0">{errorMessage}&nbsp;</h3>
          </div>
        </div>
      </div>
    );
  } else {
    return <div id="marquee"></div>;
  }
};

export default Marquee;
